
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/account-admin-tools/jst/CourseSearchResults';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n<div class=\"admin-tool-well\">\n  <div class=\"h2\">\n    <span class=\"lead\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n    <p>\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.labels.coures_id1", "Course ID:", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.labels.coures_id1", "Course ID:", options)))
    + "</strong> ";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " <br />\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.labels.account_id", "Account ID:", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.labels.account_id", "Account ID:", options)))
    + "</strong> ";
  if (helper = helpers.account_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.account_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "<br />\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.labels.course_code1", "Course Code:", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.labels.course_code1", "Course Code:", options)))
    + "</strong> ";
  if (helper = helpers.course_code) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.course_code); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "<br />\n    </p>\n  </div>\n  <button id=\"restoreCourseBtn\" class=\"btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.labels.restore_btn", "Restore", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.labels.restore_btn", "Restore", options)))
    + "</button>&nbsp;&nbsp;<span>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.info_text", "Enrollments to this course must be restored manually.", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.info_text", "Enrollments to this course must be restored manually.", options)))
    + "</span>\n</div>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n<div class=\"alert alert-error\">\n  <p class=\"text-error no-spacing\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.error_message", "A deleted course with that ID could not be found for this account.", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.error_message", "A deleted course with that ID could not be found for this account.", options)))
    + "</p>\n</div>\n";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n<div class=\"alert alert-success\" role=\"alert\">\n  <p class=\"lead\">\n  ";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " has been restored!\n  </p>\n  <div>\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.successfull_restore.subtext", "What would you like to do next?", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.successfull_restore.subtext", "What would you like to do next?", options)))
    + "</strong>\n    <div>\n      <a href=\"courses/";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"viewCourse\" class=\"btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.successful_restore.view_course", "View Course", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.successful_restore.view_course", "View Course", options)))
    + "</a>  <a href=\"/courses/";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "/users\" id=\"addEnrollments\" class=\"btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.successfull_restore.add_enrollments", "Add Enrollments", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.successfull_restore.add_enrollments", "Add Enrollments", options)))
    + "</a>\n    </div>\n  </div>\n</div>\n";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n<div class=\"alert alert-block\">\n  <div class=\"h2\">\n    <span class=\"lead\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.notdeleted_restore.header_subtext", "(Not Deleted)", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.notdeleted_restore.header_subtext", "(Not Deleted)", options)))
    + "</span>\n    <p>\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.labels.coures_id2", "Course ID:", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.labels.coures_id2", "Course ID:", options)))
    + "</strong> ";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " <br />\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.labels.account_id2", "Account ID:", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.labels.account_id2", "Account ID:", options)))
    + "</strong> ";
  if (helper = helpers.account_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.account_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "<br />\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.labels.course_code2", "Course Code:", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.labels.course_code2", "Course Code:", options)))
    + "</strong> ";
  if (helper = helpers.course_code) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.course_code); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "<br />\n    </p>\n  </div>\n\n  <div>\n    <div>\n      <a href=\"courses/";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"viewCourse\" class=\"btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.notdeleted_restore.view_course", "View Course", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.notdeleted_restore.view_course", "View Course", options)))
    + "</a>  <a href=\"/courses/";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "/users\" id=\"addEnrollments\" class=\"btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.course_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.course_search_results.notdeleted_restore.add_enrollments", "Add Enrollments", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.course_search_results.notdeleted_restore.add_enrollments", "Add Enrollments", options)))
    + "</a>\n    </div>\n  </div>\n\n</div>\n";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showRestore), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showNotFound), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showSuccessfullRestore), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showNonDeletedCourse), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  